import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ComingSoon, Eyebrow, Reveal } from "../site/motion";
import { PRODUCTS } from "../../lib/products";

const BarCard = ({ p, i }) => (
  <Reveal delay={i * 0.12}>
    <Link to={`/shop/${p.slug}`} data-testid={`featured-product-card-${p.slug}`} className="group block">
      <div className={`relative aspect-[4/5] overflow-hidden spotlight-dark ${i ? "rounded-t-[999px] rounded-b-[28px]" : "rounded-[28px]"}`}>
        <img src={p.image} alt={`${p.name} protein bar`} className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.07]" />
        <div className="absolute left-5 bottom-5"><ComingSoon /></div>
        <span className="absolute bottom-5 right-5 grid h-12 w-12 place-items-center rounded-full bg-dano-cream text-dano-ink transition-transform duration-500 group-hover:rotate-45 group-hover:bg-dano-red group-hover:text-dano-cream">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
      <p className="mt-5 font-cond text-sm uppercase tracking-[0.2em] text-dano-red">{p.number}</p>
      <h3 className="mt-1 font-wide text-3xl sm:text-4xl uppercase">{p.name}</h3>
      <p className="mt-2 text-dano-cream/80">{p.size} · {p.protein} protein · Price coming soon</p>
    </Link>
  </Reveal>
);

export const FeaturedBars = () => (
  <section data-testid="featured-bars" className="relative overflow-hidden bg-dano-ink text-dano-cream grain">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-32">
      <Reveal className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <Eyebrow>The lineup</Eyebrow>
          <h2 className="mt-4 font-wide text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.92]">Two bars.<br /><span className="text-dano-red">Coming soon.</span></h2>
        </div>
        <p className="max-w-sm text-dano-cream/80">More flavors in development.</p>
      </Reveal>
      <div className="mt-12 grid gap-10 sm:grid-cols-2 lg:gap-16">
        {PRODUCTS.map((p, i) => <BarCard key={p.slug} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
